import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import {
    HalfSlideIn,
    SlideInBody,
    StandardFirstLevelHeader,
} from '../../../ui/slidein/Slidein.tsx';
import * as TomCollectionsState from '../../state/TomCollectionsState.ts';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { DateFilterSelection } from './DateFilter.tsx';
import { TomsFilterSelection } from '../TomFilter.tsx';
import { Translation } from '../../../common/i18n/Text.ts';
import { filterHalfSlideInTexts } from '../../i18n/CollectionsTexts.ts';
import { EmptyCollectionsFilterSelection } from './EmptyCollectionsFilterSelection.tsx';
import * as CollectionActions from '../../actions/CollectionsActions.ts';
import { CollectionSticksFilter } from './CollectionSticksFilter.tsx';

export interface FilterHalfSlideInTexts {
    title: Translation;
}

export function FilterHalfSlideIn() {
    const { storeState, update } = useStore(store => ({
        filter: TomCollectionsState.Filter.get(store),
    }));
    const { language } = useLanguage();

    return (
        <HalfSlideIn open={storeState.filter.filterSlideInVisible}>
            <StandardFirstLevelHeader
                onClose={() =>
                    update(store =>
                        TomCollectionsState.Filter.stateWrite(store, {
                            filterSlideInVisible: false,
                        }),
                    )
                }
                title={filterHalfSlideInTexts[language].title()}
            />
            <SlideInBody>
                <DateFilterSelection />
                <TomsFilterSelection
                    selectedToms={storeState.filter.toms}
                    onOpenSlideIn={() =>
                        update(store =>
                            TomCollectionsState.Filter.stateWrite(store, {
                                tomSelectionVisible: true,
                            }),
                        )
                    }
                    onClear={() => update(CollectionActions.clearToms)}
                />
                <CollectionSticksFilter />
                <EmptyCollectionsFilterSelection
                    hideEmptyCollections={
                        storeState.filter.hideEmptyCollections
                    }
                    onChange={(hideEmptyCollections: boolean) =>
                        update(store =>
                            CollectionActions.setHideEmptyCollections(
                                store,
                                hideEmptyCollections,
                            ),
                        )
                    }
                    language={language}
                />
            </SlideInBody>
        </HalfSlideIn>
    );
}
